import * as React from 'react';
import { TextStyle, ViewStyle } from 'react-native';
import { Button, ButtonProperties } from 'secullum-react-native-ui';
import { Amarelo100, Cinza100 } from '../modules/layout';

// Cores dos botões de destaque (ações principais) do tema Secullum RH.
// Para botões passados como objeto ao ButtonBar/Question, use estiloBotaoDestaque
// junto com estiloTextoBotaoDestaque, para manter o contraste do texto no amarelo.
export const estiloBotaoDestaque: ViewStyle = {
  backgroundColor: Amarelo100
};

export const estiloTextoBotaoDestaque: TextStyle = {
  color: Cinza100
};

// Botão de ação principal (CTA) com o amarelo de destaque do tema Secullum RH.
const BotaoDestaque = (props: ButtonProperties) => (
  <Button
    {...props}
    style={[estiloBotaoDestaque, props.style]}
    textStyle={[estiloTextoBotaoDestaque, props.textStyle]}
  />
);

export default BotaoDestaque;
